export default  {"src":"/_next/static/image/public/images/common/loader.31b2f7a77f5cd09535424d676f623a0b.gif","height":25,"width":25};